<template>
  <div>
    <program-index
      :formSearch="formSearch"
      :enableExport="false"
      :columns="columns"
      :title="$t('menu.program_list')"
      :serviceName="serviceName"
    />
  </div>
</template>

<script>
import ProgramIndex from "./ProgramIndex";
import { ProgramDivisionService } from "../../services/programDivision.service";
import { NationService } from "../../services/nation.service";
import { mapGetters, mapMutations } from "vuex";
import { ProgramTypeService } from "../../services/programType.service";

export default {
  name: "Index",
  data() {
    return {
      serviceName: "program",
      formSearch: [
        {
          label: this.$t("program.program_name_en"),
          name: "name__~",
          value: "",
          type: "input"
        },
        {
          label: this.$t("program.program_division_name"),
          name: "program_division_id",
          value: "",
          type: "select",
          options: []
        },
        {
          label: this.$t("university.nation"),
          name: "country_alpha_two_code",
          value: "",
          type: "select2",
          options: []
        },
        {
          label: this.$t("program.program_type_name"),
          name: "program_type_id",
          value: "",
          type: "select",
          options: []
        },
        {
          label: this.$t("program.university_name_en"),
          name: "university_name__~",
          value: "",
          type: "input"
        }
      ],
      columns: {
        id: this.$t("program.id"),
        avatar: this.$t("program.avatar"),
        name: this.$t("program.program_name_en"),
        university_name: this.$t("program.university_name_en"),
        university_address: this.$t("program.university_address"),
        nation: this.$t("university.nation"),
        created_at: this.$t("program.created_at"),
        updated_at: this.$t("program.updated_at")
      }
    };
  },
  components: { ProgramIndex },
  methods: {
    ...mapMutations({
      setNationOptions: "SET_NATION_OPTIONS"
    }),
    async getProgramDivisionOptions() {
      const response = await new ProgramDivisionService().getList();
      this.formSearch[1].options = response.data;
    },
    async getProgramTypeOptions() {
      const response = await new ProgramTypeService().getList();
      this.formSearch[3].options = response.data;
    },
    async getNation() {
      if (this.nationsOptions && this.nationsOptions.length > 0) {
        this.formSearch[2].options = this.nationsOptions;
        return;
      }
      const response = new NationService().getListPublic();
      let nations = response.data;
      let nationOptions = [];
      nations.forEach(nation => {
        nationOptions.push({
          id: nation.alpha2Code,
          text: nation.name,
          country_alpha_three_code: nation.alpha3Code
        });
      });
      this.formSearch[2].options = nationOptions;
      this.setNationOptions(nationOptions);
    }
  },
  mounted() {
    this.getProgramDivisionOptions();
    this.getProgramTypeOptions();
    this.getNation();
  },
  computed: {
    ...mapGetters({ nationsOptions: "nationsOptions" })
  }
};
</script>
